import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, SearchResultsReducer, ISearchResultsState, initialState } from './search-results-reducer';

const SearchResultsContext = createContext<ISearchResultsState | undefined>(undefined);
const SearchResultsContextDispatchContext = createContext({} as any);

const SearchResultsProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(SearchResultsReducer, initialState);

    return (
        <SearchResultsContext.Provider value={state}>
            <SearchResultsContextDispatchContext.Provider value={dispatch}>
                {children}
            </SearchResultsContextDispatchContext.Provider>
        </SearchResultsContext.Provider>
    );
}

const useSearchResultsState = () => {
    const context = useContext(SearchResultsContext);
    if (context === undefined) {
        throw new Error('useSearchResultsState must be used within a SearchResultsProvider');
    }
    return context;
}

const useSearchResultsDispatch = () => {
    const context = useContext(SearchResultsContextDispatchContext);
    if (context === undefined) {
        throw new Error('useSearchResultsDispatch must be used within a SearchResultsProvider');
    }
    return context;
}

export { SearchResultsProvider, useSearchResultsState, useSearchResultsDispatch, ACTION_TYPES };
